import type {HttpError} from '@hconnect/common/types'
import type {AssetConfigurationDto} from '@hconnect/kilnfeature/src/types'
import {useQuery} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

import {useSelectedItem} from '../../providers'

import {Api} from '@settings/api'

// TODO: might be replaced with the one from kilnfeature
// (https://jira.heidelbergcement.com/browse/HCP-97660)
export const useGetAssetConfig = (assetId: string) => {
  const {upmPlantId} = useSelectedItem()

  return useQuery<AssetConfigurationDto, AxiosError<HttpError>>({
    queryKey: ['asset-config', upmPlantId, assetId],
    queryFn: async () => {
      const path = `asset-config/kms-data/plant/${upmPlantId}/upm-type/Department`
      return (
        await Api.axiosInstance.get<AssetConfigurationDto>(path, {
          params: {
            typeUpmId: assetId
          }
        })
      ).data
    },
    retry: (retryCount, error) => error?.response?.status !== 404 && retryCount < 3,
    throwOnError: false
  })
}
